import {LocalesEnum} from 'interfaces/ui'
import {action, computed, makeAutoObservable, observable} from 'mobx'
import {DefaultTheme} from 'styled-components'

import {ThemeEnum} from '../../interfaces/styled'
import {darkTheme, lightTheme} from '../../styles/theme'

const getTheme = () => {
  const storageThemeType = localStorage.getItem('theme-type')
  if (storageThemeType === ThemeEnum.dark) {
    return darkTheme
  }
  return lightTheme
}

const getLocale = () => {
  const storageLocale = localStorage.getItem('locale');
  if (storageLocale) {
    switch (storageLocale) {
      case LocalesEnum.RUSSIAN:
        return LocalesEnum.RUSSIAN;
      case LocalesEnum.ENGLISH:
        return LocalesEnum.ENGLISH
    }
  } else {
    // TODO взять локаль из заголовков
  }

  return LocalesEnum.RUSSIAN
}

export class UIStore {
  theme: DefaultTheme = lightTheme
  locale: LocalesEnum = LocalesEnum.RUSSIAN
  
  constructor() {
    makeAutoObservable(this, {
      theme: observable,
      isLightTheme: computed,
      toggleTheme: action,
      getLocale: computed,
      setLocale: action
    });
    this.theme = getTheme() 
    this.locale = getLocale()
  }

  get isLightTheme() {
    return this.theme.type === ThemeEnum.light;
  }

  toggleTheme = () => {
    this.theme = this.isLightTheme ? darkTheme : lightTheme
    localStorage.setItem('theme-type', this.theme.type)
  }

  get getLocale() {
    return this.locale;
  }

  setLocale = (locale: LocalesEnum) => {
    this.locale = locale
    localStorage.setItem('locale', locale)
  }
}
